import Vue from "vue";
import { Image as VanImage, Sticky, Popup, Area } from "vant";

Vue.use(VanImage).use(Sticky).use(Popup).use(Area);
